import { request } from "@/interface/helper";

const str = "feedsRecommend";

export const feedsRecommend = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/newsrecommend/list" }),
    add: (data) => request({ data, method: "post", url: "/newsrecommend/add" }),
    detail: (data) => request({ data, method: "post", url: "/newsrecommend/detail" }),
    edit: (data) => request({ data, method: "post", url: "/newsrecommend/modify" }),
  },
};
